import {
  BarIcon,
  IconArrowDown,
  IconCalendar,
  IconRemoved,
  Iconreview,
  IconTable,
  IconTimeline,
  IconToDo,
  Imgcompleted,
  Imgprogress,
  Imgstatus,
} from 'src/components/Icons';
import i18n from 'i18next';
import { IconEye } from '../components/Icons/eye';
import { IconEdit2 } from '../components/Icons/edit2';
import React from 'react';
import { CheckCircleOutlined, SafetyOutlined } from '@ant-design/icons';
import { IconFilledDot, IconSetting, IconSettingActive } from '../components/Icons/svgIcon';


const constants = {
  AXIOS: {
    HTTP_STATUS: {
      FORBIDDEN: 403,
      UNAUTHORIZED: 401,
      BAD_REQUEST: 400,
      SUCCESS: 200,
    },
  },

  BASE_SERVICE_URL: `${process.env.REACT_APP_API_URL}`,
  APP_LOGOUT: `${
    process.env.REACT_APP_BASE_URL &&
    process.env.REACT_APP_BASE_URL !== '/' &&
    process.env.REACT_APP_BASE_URL !== '.'
      ? process.env.REACT_APP_BASE_URL + '/sso-logout'
      : '/sso-logout'
  }`,
  TASK_LIST_URL: `${process.env.REACT_APP_URL_TASK_LIST}`,
  PROJECT_LIST_URL: `${process.env.REACT_APP_URL_PROJECT_LIST}`,
  REACT_APP_SSO_SESSION_ID_KEY: `${process.env.REACT_APP_SSO_SESSION_ID_KEY}`,
  BASE_URL: `${
    process.env.REACT_APP_BASE_URL &&
    process.env.REACT_APP_BASE_URL !== '/' &&
    process.env.REACT_APP_BASE_URL !== '.'
      ? process.env.REACT_APP_BASE_URL
      : ''
  }`,
  FORCE_CHANGE_PASSWORD_PATH: '/doi-mat-khau-bat-buoc',
  MESSAGE_DURATION: 5,
  STORAGE_KEY: {
    ROLE_CODE: 'roleCode',
    DEPT_CODE: 'deptCoe',
    TOKEN_DATA: 'tokenData',
  },
  COUNTDOWN_LOGOUT_DURATION: 5,
  PROJECT_DAYS_BEFORE_ENDDATE: 7,
  WARNING_DAYS: 7,
  START_COUNT_DAYS: 30,

  FORMAT_DATE_EN: 'MM/DD/YYYY',
  FORMAT_LOCAL_DATE: 'YYYY-MM-DD',
  FORMAT_DATE_TIME: 'DD/MM/YYYY',
  FORMAT_DATE_MONTH: 'DD/MM',
  FORMAT_DATE_MONTH_YEAR: 'MM/YYYY',
  FORMAT_DATE_YEAR: 'YYYY',
  FORMAT_DATE_TIME_WITH_HOUR: 'HH:mm DD/MM/YYYY',
  FORMAT_DATE_TIME_STRING: 'YYYYMMDDHHmm',
  FORMAT_TIME: 'HH:mm',
  MAX_CHARACTERS: 50,
  FETCH_STATUS: {
    IDLE: 'idle',
    LOADING: 'loading',
    READY: 'ready',
  },
  ACTION_STATUS: {
    SUCCESS: 'success',
    ERROR: 'error',
  },
  TASK: {
    STATUS_ASSIGNER_EDITABLE: [
      'wait_confirm',
      'processing',
      'wait_done',
    ],
    STATUS_ASSIGNER_DELETEABLE: [
      'wait_confirm',
      'processing',
      'wait_done',
    ],
    STATUS_ASSIGNER_CANCELABLE: [
      'wait_confirm',
      'processing',
      'wait_done',
    ],
    STATUS_ASSIGNED_EDITABLE: ['draft', 'processing'],
    STATUS_ASSIGNED_DELETEABLE: ['draft', 'wait_confirm'],
    STATUS_ASSIGNED_CANCELABLE: [
      'draft',
      'wait_confirm',
      'processing',
    ],
  },
  STATUS_CODE: {
    DRAFT: 'draft',
    WAIT_CONFIRM: 'wait_confirm',
    PROCESSING_NOLATE: 'processing_nolate',
    PROCESSING: 'processing',
    WAIT_DONE: 'wait_done',
    NO_DONE: 'no_done',
    DONE: 'done',
    DONE_NOLATE: 'done_nolate',
    DONE_LATE: 'done_late',
    LATE: 'late',
    CANCEL: 'cancel',
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    DEACTIVE: 'deactive',
  },
  ITEM_STATUS: [
    {
      code: 'active',
      name: 'Đang hoạt động',
      color: 'green',
    },
    {
      code: 'inactive',
      name: 'Không hoạt động',
      color: 'red',
    },
  ],
  STATUS: [
    {
      code: 'draft',
      desc: i18n.t('task.status.draft'),
      bg: 'rgb(230, 230, 230)',
      color: '#666666',
    },
    {
      code: 'wait_confirm',
      desc: i18n.t('task.status.wait_confirm'),
      bg: 'rgba(255, 153, 0, 0.1)',
      color: '#FF9900',
    },
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
    {
      code: 'done',
      desc: i18n.t('task.status.done'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'cancel',
      desc: i18n.t('task.status.cancel'),
      bg: 'rgba(221, 0, 0, 0.1)',
      color: '#DD0000',
    },
  ],
  REPORT_STATUS: [
    {
      code: 'draft',
      desc: i18n.t('task.status.draft'),
      bg: 'rgb(230, 230, 230)',
      color: '#666666',
    },
    {
      code: 'wait_confirm',
      desc: i18n.t('task.status.wait_confirm'),
      bg: 'rgba(255, 153, 0, 0.1)',
      color: '#FF9900',
    },
    {
      code: 'processing_nolate',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
    {
      code: 'done',
      desc: i18n.t('task.status.done'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
  ],
  PROJECT_STATUS_CODE: {
    PROCESSING: 'processing',
    NEARING_COMPLETION: 'nearing_completion',
    DONE: 'done',
    DONE_ONTIME: 'done_ontime',
    LATE: 'late',
  },
  PROJECT_STATUS: [
    {
      code: 'processing',
      name: i18n.t('project.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'nearing_completion',
      name: i18n.t('project.status.nearing_completion'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#FF9900',
    },
    {
      code: 'done',
      name: i18n.t('project.status.done'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'late',
      name: i18n.t('project.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
  ],
  REPORT_DEPT_TASK_STATUS: [
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'done',
      desc: i18n.t('task.status.done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
  ],
  REPORT_HOME_STATUS_MANAGER: [
    {
      code: 'wait_confirm',
      desc: i18n.t('task.status.wait_confirm_manager'),
      bg: 'rgba(255, 153, 0, 0.1)',
      color: '#FF9900',
    },
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done_manager'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
    {
      code: 'draft',
      desc: i18n.t('task.status.draft'),
      bg: 'rgb(230, 230, 230)',
      color: '#A7A7A7',
    },
  ],
  REPORT_HOME_STATUS_MEMBER: [
    {
      code: 'wait_confirm',
      desc: i18n.t('task.status.wait_confirm'),
      bg: 'rgba(255, 153, 0, 0.1)',
      color: '#FF9900',
    },
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
    {
      code: 'draft',
      desc: i18n.t('task.status.draft'),
      bg: 'rgb(230, 230, 230)',
      color: '#A7A7A7',
    },
  ],
  REPORT_TASK_STATUS: [
    // {
    //   code: 'draft',
    //   desc: i18n.t('task.status.draft'),
    //   bg: 'rgba(255, 153, 0, 0.1)',
    //   color: '#FF9900',
    // },
    {
      code: 'wait_confirm',
      desc: i18n.t('task.status.wait_confirm'),
      bg: 'rgba(255, 153, 0, 0.1)',
      color: '#FF9900',
    },
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
    {
      code: 'done',
      desc: i18n.t('task.status.done_ontime'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'done_late',
      desc: i18n.t('task.status.done_late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#99C48C',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
  ],
  REPORT_TASK_NO_APPROVAL_STATUS: [
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'done',
      desc: i18n.t('task.status.done_ontime'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'done_late',
      desc: i18n.t('task.status.done_late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#99C48C',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
  ],
  REPORT_HOME_TASK_STATUS: [
    {
      code: 'done',
      desc: i18n.t('task.status.done_ontime'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
    {
      code: 'done_late',
      desc: i18n.t('task.status.done_late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#99C48C',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
  ],
  REPORT_PROJECT_TASK_STATUS: [
    {
      code: 'done',
      desc: i18n.t('task.status.done_ontime'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 'done_late',
      desc: i18n.t('task.status.done_late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#99C48C',
    },
    {
      code: 'late',
      desc: i18n.t('task.status.late'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#DD0000',
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
    },
  ],
  TODO_STATUS: [
    {
      code: 'draft',
      desc: i18n.t('task.status.draft'),
      bg: 'rgb(230, 230, 230)',
      color: '#A7A7A7',
      checkbox: (
        <IconToDo
          className="img-status"
          width={21}
          height={21}
        />
      ),
    },
    {
      code: 'wait_confirm',
      desc: i18n.t('task.status.wait_confirm'),
      bg: 'rgba(255, 153, 0, 0.1)',
      color: '#FF9900',
      checkbox: <Imgstatus className="img-status" />,
    },
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
      checkbox: <Imgprogress className="img-status" />,
    },
    {
      code: 'wait_done',
      desc: i18n.t('task.status.wait_done'),
      bg: 'rgba(0, 90, 196, 0.1)',
      color: '#005AC4',
      checkbox: <Iconreview className="img-status" />,
    },
    {
      code: 'done',
      desc: i18n.t('task.status.done'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
      checkbox: <Imgcompleted className="img-status" />,
    },
    {
      code: 'cancel',
      desc: i18n.t('task.status.cancel'),
      bg: 'rgba(221,0,0,0.1)',
      color: '#DD0000',
      checkbox: (
        <IconRemoved
          width={21}
          height={21}
          className="img-status"
        />
      ),
    },
  ],
  TODO_NO_APPROVAL_STATUS: [
    {
      code: 'processing',
      desc: i18n.t('task.status.processing'),
      bg: 'rgba(0, 169, 222, 0.1)',
      color: '#00A9DE',
      checkbox: <Imgprogress className="img-status" />,
    },
    {
      code: 'done',
      desc: i18n.t('task.status.done'),
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
      checkbox: <Imgcompleted className="img-status" />,
    },
  ],
  HISTORY_ACTIONS: [
    {
      code: 1,
      name: i18n.t('history_actions.create'),
      icon: 'fas fa-plus',
    },
    {
      code: 2,
      name: i18n.t('history_actions.update'),
      icon: 'fas fa-pen',
    },
    {
      code: 3,
      name: i18n.t('history_actions.delete'),
      icon: 'fas fa-trash',
    },
    {
      code: 4,
      name: i18n.t('history_actions.add'),
      icon: 'fas fa-plus',
    },
    {
      code: 5,
      name: i18n.t('history_actions.edit'),
      icon: 'fas fa-pen',
    },
    {
      code: 6,
      name: i18n.t('history_actions.status'),
      icon: 'fas fa-pen',
    },
    {
      code: 7,
      name: i18n.t('history_actions.task_confirm'),
      icon: 'fas fa-pen',
    },
    {
      code: 8,
      name: i18n.t('history_actions.task_done'),
      icon: 'fas fa-pen',
    },
    {
      code: 9,
      name: i18n.t('history_actions.setting'),
      icon: 'fas fa-pen',
    },
  ],
  NOTIFICATION_ACTION: [
    {
      code: 'created',
      desc: i18n.t('notification.actions.created'),
    },
    {
      code: 'updated',
      desc: i18n.t('notification.actions.updated'),
    },
    {
      code: 'deleted',
      desc: i18n.t('notification.actions.deleted'),
    },
  ],
  NOTIFICATION_FUNCTION: [
    {
      code: 'role',
      desc: i18n.t('notification.functions.role'),
    },
    {
      code: 'team',
      desc: i18n.t('notification.functions.team'),
    },
    {
      code: 'project',
      desc: i18n.t('notification.functions.project'),
    },
    {
      code: 'task',
      desc: i18n.t('notification.functions.task'),
    },
  ],
  APPROVAL: [
    {
      code: 0,
      desc: i18n.t('approval.no'),
    },
    {
      code: 1,
      desc: i18n.t('approval.yes'),
    },
  ],
  PROJECT_TYPE_KEY: {
    IN: '1',
    OUT: '2',
  },
  PROJECT_TYPE: [
    {
      code: '1',
      desc: i18n.t('project.type.in'),
    },
    {
      code: '2',
      desc: i18n.t('project.type.out'),
    },
  ],
  LABEL: [
    {
      code: 'isUrgent',
      desc: i18n.t('task.label.isUrgent'),
      bg: 'rgba(221, 0, 0, 0.1)',
      color: '#DD0000',
    },
  ],
  DAYSLEFT: [
    {
      code: 1,
      bg: 'rgba(0, 196, 140, 0.1)',
      color: '#00C48C',
    },
    {
      code: 2,
      bg: 'rgba(255, 153, 0, 0.1)',
      color: '#FF9900',
    },
    {
      code: 3,
      bg: 'rgba(221, 0, 0, 0.1)',
      color: '#DD0000',
    },
  ],

  SETTING_SELECT: {
    filterOption: true,
    optionFilterProp: 'children',
    showSearch: true,
    allowClear: true,
    showArrow: true,
    // dropdownMatchSelectWidth: false,
  },
  SETTING_SELECT_MULTI: {
    filterOption: true,
    optionFilterProp: 'children',
    showSearch: true,
    allowClear: true,
    showArrow: true,
    // dropdownMatchSelectWidth: false,
    mode: 'multiple' as any,
  },
  NOTICE_FILTER: [
    {
      label: 'Tất cả',
      value: '',
      icon: <IconCalendar />,
    },
    {
      label: 'Hôm nay',
      value: '1',
      icon: <IconCalendar />,
    },
    {
      label: 'Tuần này',
      value: '2',
      icon: <IconCalendar />,
    },
  ],
  LIST_FILTER: [
    {
      title: 'Bảng',
      icon: <IconTable />,
    },
    {
      title: 'List',
      icon: <BarIcon height={10} width={16} />,
    },
  ],
  LIST_GRID: [
    {
      title: 'List',
      icon: <BarIcon height={10} width={16} />,
      iconAffter: <IconArrowDown />,
    },
    {
      title: 'Lưới ',
      icon: <IconTable />,
    },
  ],
  LIST_FILTER_MULTIPLE: [
    {
      title: 'List',
      icon: <BarIcon height={10} width={16} />,
      iconAffter: <IconArrowDown />,
    },
    {
      title: 'Bảng',
      icon: <IconTable />,
    },
    {
      title: 'Lịch',
      icon: <IconCalendar />,
    },
    {
      title: 'Timeline',
      icon: <IconTimeline size={14} color={`959595`} />,
    },
  ],
  TASK_SORT: [
    {
      label: 'Ưu tiên cao nhất',
      value: 'priority,asc',
      icon: 'far fa-chevron-double-up',
    },
    {
      label: 'Ưu tiên thấp nhất',
      value: 'priority,desc',
      icon: 'far fa-chevron-double-down',
    },
    {
      label: 'Ngày kết thúc',
      value: '',
      icon: 'far fa-clock',
    },
  ],
  TASK_PRIORITY: [
    {
      label: 'Ưu tiên cao',
      value: 1,
      icon: 'fas fa-chevron-double-up',
    },
    {
      label: 'Trung bình',
      value: 2,
      icon: 'fas fa-grip-lines',
    },
    {
      label: 'Ưu tiên thấp',
      value: 3,
      icon: 'fas fa-chevron-double-down',
    },
  ],
  TASK_COMPLEXITY: [
    {
      label: 'Phức tạp',
      value: 'Phức tạp',
    },
    {
      label: 'Trung bình',
      value: 'Trung bình',
    },
    {
      label: 'Đơn giản',
      value: 'Đơn giản',
    },
  ],
  TASK_FILTER_STATUS: {
    WAIT_CONFIRM: 'wait_confirm',
    PROCESSING: 'processing',
    WAIT_DONE: 'wait_done',
    DONE: 'done',
    DONE_LATE: 'done_late',
    NOT_START: 'not_start',
    UNLIMITED: 'unlimited',
    LATE: 'late',
    IMPORTANT: 'important',
    URGENT: 'urgent',
  },
  LIST_TASK_FILTER_STATUS: [
    {
      label: 'Tất cả',
      value: '',
      icon: 'far fa-list-ul',
    },
    {
      label: 'Chờ duyệt thực hiện',
      value: 'wait_confirm',
      icon: 'far fa-tag',
    },
    {
      label: 'Đang thực hiện',
      value: 'processing',
      icon: 'far fa-tag',
    },
    {
      label: 'Chờ duyệt hoàn thành',
      value: 'wait_done',
      icon: 'far fa-tag',
    },
    {
      label: 'Hoàn thành',
      value: 'done',
      icon: 'far fa-tag',
    },
    {
      label: 'Hoàn thành quá hạn',
      value: 'done_late',
      icon: 'far fa-tag',
    },
    {
      label: 'Chưa có thời hạn',
      value: 'unlimited',
      icon: 'far fa-tag',
    },
    {
      label: 'Quá hạn',
      value: 'late',
      icon: 'far fa-tag',
    },
  ],
  TASK_DISPLAY: [
    {
      label: 'Tất cả',
      value: '',
      icon: 'far fa-list-ul',
    },
    {
      label: 'Công việc chính',
      value: 'task',
      icon: 'far fa-tag',
    },
  ],
  TASK_GROUP: [
    {
      label: 'Thời gian',
      value: '1',
      icon: 'far fa-clock',
    },
    {
      label: 'Người xử lý',
      value: '2',
      icon: 'far fa-user-check',
    },
    {
      label: 'Dự án',
      value: '3',
      icon: 'far fa-file',
    },
    {
      label: 'Phòng ban',
      value: '4',
      icon: 'fas fa-th-large',
    },
    {
      label: 'Nhóm công việc',
      value: '5',
      icon: 'fas fa-layer-group',
    },
  ],
  TASK_FREQUENCY: {
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
    YEARLY: 'yearly',
  },
  LIST_TASK_FREQUENCY: [
    {
      label: 'Hằng tuần',
      value: 'weekly',
    },
    {
      label: 'Hằng tháng',
      value: 'monthly',
    },
    {
      label: 'Hằng năm',
      value: 'yearly',
    },
  ],
  LIST_WEEK_DAYS: [
    {
      label: 'Chủ nhật',
      value: '0',
    },
    {
      label: 'Thứ 2',
      value: '1',
    },
    {
      label: 'Thứ 3',
      value: '2',
    },
    {
      label: 'Thứ 4',
      value: '3',
    },
    {
      label: 'Thứ 5',
      value: '4',
    },
    {
      label: 'Thứ 6',
      value: '5',
    },
    {
      label: 'Thứ 7',
      value: '6',
    },
  ],
  ROLES_EDITABLE: [
    {
      label: 'Lãnh đạo đơn vị',
      value: 'role-leader',
    },
    {
      label: 'Quản lý đơn vị',
      value: 'role-admin',
    },
    {
      label: 'Quản lý dự án',
      value: 'role-project-admin',
    },
    {
      label: 'Thành viên',
      value: 'role-member',
    },
  ],
  ROLES: [
    {
      label: 'Quản trị hệ thống',
      value: 'role-owner',
    },
    {
      label: 'Lãnh đạo đơn vị',
      value: 'role-leader',
    },
    {
      label: 'Quản lý đơn vị',
      value: 'role-admin',
    },
    {
      label: 'Quản lý dự án',
      value: 'role-project-admin',
    },
    {
      label: 'Thành viên',
      value: 'role-member',
    },
  ],
  ROLES_KEY: {
    OWNER: 'role-owner',
    LEADER: 'role-leader',
    ADMIN: 'role-admin',
    PROJECT_ADMIN: 'role-project-admin',
    MEMBER: 'role-member',
  },
  FUNCTION_KEYS: {
    TINTUYENDUNG: 'tin-tuyen-dung',
    KEHOACHTUYENDUNG: 'ke-hoach-tuyen-dung',
    UNGVIEN: 'ung-vien',
    LICHPHONGVAN: 'lich-phong-van',
    HETHONG: 'he-thong',
    BAOCAO: 'bao-cao',
    VAITRO: 'role',
  },
  USER_ROLES: {
    CREATE: 'create',
    READ: 'read',
    UPDATE: 'update',
    DELETE: 'delete',
    COPY: 'copy',
    APPROVAL: 'approval',
  },
  PROJECT_SETTING: [
    {
      label: 'Phê duyệt công việc trong dự án',
      value: 'approval',
    },
    {
      label: 'Tạo mới công việc',
      value: 'new-task',
    },
    {
      label: 'Tạo nhóm công việc mới',
      value: 'new-group-task',
    },
    {
      label: 'Xem công việc toàn bộ dự án',
      value: 'view-all',
    },
    {
      label: 'Gán công việc cho người khác',
      value: 'assign',
    },
    {
      label: 'Xem báo cáo tổng thể',
      value: 'report',
    },
    {
      label: 'Tạo thư mục tài liệu, upload tài liệu',
      value: 'upload-file',
    },
    {
      label: 'Tạo cuộc thảo luận trong dự án',
      value: 'new-group-chat',
    },
  ],
  PROJECT_SETTING_KEY: {
    APPROVAL: 'approval',
    NEW_TASK: 'new-task',
    NEW_GROUP_TASK: 'new-group-task',
    VIEW_ALL: 'view-all',
    ASSIGN: 'assign',
    REPORT: 'view-report',
    UPLOAD_FILE: 'upload-file',
    NEW_GROUP_CHAT: 'new-group-chat',
  },
  USERLOG_ACTIONS: [
    {
      label: 'Thêm',
      value: 'created',
    },
    {
      label: 'Sửa',
      value: 'updated',
    },
    {
      label: 'Xóa',
      value: 'deleted',
    },
  ],
  FUNCTIONS_CODE: [
    {
      label: 'Công việc',
      value: 'task',
    },
    {
      label: 'Nhóm thành viên',
      value: 'team',
    },
    {
      label: 'Nhóm quyền',
      value: 'role',
    },
    {
      label: 'Dự án',
      value: 'project',
    },
    {
      label: 'Công việc con',
      value: 'subtask',
    },
  ],
  LIST_FILTER_DATE: [
    {
      title: 'Ngày',
      iconAffter: <IconArrowDown />,
    },
    {
      title: 'Tuần',
      iconAffter: <IconArrowDown />,
    },
    {
      title: 'Tháng',
      iconAffter: <IconArrowDown />,
    },
    {
      title: 'Năm',
      iconAffter: <IconArrowDown />,
    },
  ],

  CATEGORY_KEYS: {
    viTriCongViec: 'vi-tri-cong-viec',
    nganhNghe: 'nganh-nghe',
    capBac: 'cap-bac',
    tagUngVien: 'tag-ung-vien',
    phongHop: 'phong-hop',
  },
  CATEGORY: [
    {
      languagePackage: 'viTriCongViec',
      phanLoai: 'vi-tri-cong-viec',
      maDanhMuc: 'Mã vị trí công việc',
      tenDanhMuc: 'Tên vị trí công việc',
      name: 'Vị trí công việc',
      idDonVi: 'Phòng ban',
      tenDonVi: 'Phòng ban',
      idsCapTren: 'nganh-nghe',
      tensCapTren: 'Ngành nghề',
      orderNo: 'Thứ tự hiển thị',
      isCodeRequired: true,
      isCheckSpecialChar: true,
    },
    {
      languagePackage: 'nganhNghe',
      phanLoai: 'nganh-nghe',
      maDanhMuc: 'Mã ngành nghề',
      tenDanhMuc: 'Tên ngành nghề',
      name: 'Ngành nghề',
      idDonVi: 'Phòng ban',
      tenDonVi: 'Phòng ban',
      orderNo: 'Thứ tự hiển thị',
      isCodeRequired: true,
      isCheckSpecialChar: true,
    },
    {
      languagePackage: 'capBac',
      phanLoai: 'cap-bac',
      maDanhMuc: 'Mã cấp bậc',
      tenDanhMuc: 'Tên cấp bậc',
      name: 'Cấp bậc',
      idDonVi: 'Phòng ban',
      tenDonVi: 'Phòng ban',
      orderNo: 'Thứ tự hiển thị',
      isCodeRequired: true,
      isCheckSpecialChar: true,
    },
    {
      languagePackage: 'tagUngVien',
      phanLoai: 'tag-ung-vien',
      maDanhMuc: 'Mã tag',
      tenDanhMuc: 'Tên tag',
      name: 'Tag ứng viên',
      orderNo: 'Thứ tự hiển thị',
      isCodeRequired: false,
      isCheckSpecialChar: true,
    },
    {
      languagePackage: 'phongHop',
      phanLoai: 'phong-hop',
      maDanhMuc: 'Mã phòng họp',
      tenDanhMuc: 'Tên phòng họp',
      name: 'Phòng họp',
      idDonVi: 'Phòng ban',
      tenDonVi: 'Phòng ban',
      isCodeRequired: true,
      isCheckSpecialChar: true,
    },
    {
      languagePackage: 'default',
      phanLoai: 'default',
      maDanhMuc: 'Mã danh mục',
      tenDanhMuc: 'Tên danh mục',
      name: 'danh mục',
      orderNo: 'Thứ tự hiển thị',
      isCodeRequired: false,
      isCheckSpecialChar: true,
    },
  ],
  HINH_THUC_CONG_VIEC: [
    {
      code: 'full-time',
      name: 'Toàn thời gian',
    },
    {
      code: 'part-time',
      name: 'Bán thời gian',
    },
  ],
  COLORS: [
    {
      code: '#D9D9D9',
    },
    {
      code: '#F36666',
    },
    {
      code: '#F3C47C',
    },
    {
      code: '#6EEDB8',
    },
    {
      code: '#70CBF2',
    },
    {
      code: '#B9B8FA',
    },
    {
      code: '#F1B8FA',
    },
    {
      code: '#F37CA0',
    },
    {
      code: '#73A4EE',
    },
    {
      code: '#51829D',
    },
  ],
  CHI_PHI_TUYEN_DUNG: [
    {
      code: 'kenh',
      name: 'Chi phí tuyển dụng theo kênh',
    },
    {
      code: 'khac',
      name: 'Chi phí khác',
    },
  ],
  KENH_TUYEN_DUNG: [
    {
      code: 'topcv',
      name: 'TopCV',
    },
    {
      code: 'vietnamworks',
      name: 'VietnamWorks',
    },
  ],
  STATUS_TIN_TUYEN_DUNG: [
    {
      code: 'temp',
      name: 'Lưu nháp',
      type: 'default',
    },
    {
      code: 'cong-khai',
      name: 'Công khai',
      type: 'success',
    },
    {
      code: 'ngung-tuyen-dung',
      name: 'Ngừng tuyển dụng',
      type: 'error',
    },
  ],
  STATUS_KE_HOACH_TUYEN_DUNG: [
    {
      code: 'cong-khai',
      name: 'Công khai',
      type: 'success',
    },
    {
      code: 'ngung-tuyen-dung',
      name: 'Ngừng nhận hồ sơ',
      type: 'error',
    },
    {
      code: 'het-han',
      name: 'Hết hạn',
      type: 'default',
    },
  ],
  STATUS_UNG_VIEN: [
    {
      code: 'sync',
      name: 'Đồng bộ',
      type: 'default',
    },
    {
      code: 'in_progress',
      name: 'Đang thực hiện',
      type: 'default',
    },
    {
      code: 'confirm',
      name: 'Đã tuyển',
      type: 'success',
    },
    {
      code: 'reject',
      name: 'Loại',
      type: 'error',
    },
  ],
  EMAIL_KEYS: [
    {
      code: '1',
      name: 'Tên công ty',
    },
    {
      code: '2',
      name: 'Tên ứng viên',
    },
    {
      code: '3',
      name: 'Vị trí tuyển dụng',
    },
    {
      code: '4',
      name: 'Thời gian phỏng vấn',
    },
    {
      code: '5',
      name: 'Địa điểm phỏng vấn',
    },
    {
      code: '6',
      name: 'Lưu ý cho ứng viên',
    },
    {
      code: '7',
      name: 'Số điện thoại HR',
    },
    {
      code: '8',
      name: 'Email HR',
    },
  ],

  BADGE_TYPES: {
    USER_STATUS: 'USER_STATUS',
    ACTIVE_STATUS: 'ACTIVE_STATUS',
    PASSWORD_REQUEST_STATUS: 'PASSWORD_REQUEST_STATUS',
    ROLE: 'ROLE',
  },

  ACCOUNT_TYPE: [
    {
      code: 'CAN_BO',
      label: 'Cán bộ',
    },
    {
      code: 'CA_NHAN',
      label: 'Cá nhân',
    },
    {
      code: 'TO_CHUC',
      label: 'Tổ chức',
    },
  ],
  ROLE: [
    { code: 'ADMIN', label: 'Admin', color: '#DA251D' },
    { code: 'DASHBOARD', label: 'Dashboard' },
    { code: 'USER_MANAGER', label: 'User manager' },
    { code: 'SSO_APP_MANAGEMENT', label: 'Sso app management' },
    { code: 'UNIT_MANAGER', label: 'Unit manager' },
    { code: 'ROLE_MANAGEMENT', label: 'Role management' },
    { code: 'CONFIG_MANAGEMENT', label: 'Config management' },
    { code: 'APP_MANAGEMENT', label: 'App management' },
    { code: 'USER', label: 'User' },
    { code: 'UNIT', label: 'Unit' },
    { code: 'APP', label: 'App' },
    { code: 'CONFIG', label: 'Config' },
    { code: 'EXPORT_USER', label: 'Export user', color: '#0B1220' },
  ].map(role => ({
    color: '#0A1F44',
    ...role,
    icon: <IconSettingActive width={14} height={14} />,
  })),

  USER_STATUS: [
    {
      code: 'ACTIVE',
      label: 'Hoạt động',
      icon: <IconFilledDot color={'#008235'} />,
      color: '#008235'
    },
    {
      code: 'INACTIVE',
      label: 'Chờ xác thực',
      icon: <IconFilledDot color={'#0A1F44'} />,
      color: '#0A1F44'
    },
    {
      code: 'TEMP_LOCKED',
      label: 'Tạm khoá',
      icon: <IconFilledDot color={'#FAAD14'} />,
      color: '#FAAD14'
    },
  ],

  ACTIVE_STATUS: [
    {
      code: 'ACTIVE',
      label: 'Đang hoạt động',
      icon: <IconFilledDot color={'#008235'} />,
      color: '#008235',
    },
    {
      code: 'INACTIVE',
      label: 'Không hoạt động',
      icon: <IconFilledDot color={'#0A1F44'} />,
      color: '#0A1F44',
    },
  ],

  PASSWORD_REQUEST_STATUS: [
    {
      code: 'CHUA_XU_LY',
      label: 'Chưa xử lý',
      icon: <IconFilledDot color={'#FAAD14'} />,
      color: '#FAAD14',
    },
    {
      code: 'DA_XU_LY',
      label: 'Đã xử lý',
      icon: <IconFilledDot color={'#008235'} />,
      color: '#008235',
    },
  ],

  ACCOUNT_TYPE_ITEM: [
    {
      key: 'CAN_BO',
      label: 'Cán bộ',
    },
    {
      key: 'CA_NHAN',
      label: 'Cá nhân',
    },
    {
      key: 'TO_CHUC',
      label: 'Tổ chức',
    }
  ],

  POSITIONS: [
    { label: "Đại tướng", code: "DAI_TUONG" },
    { label: "Thượng tướng", code: "THUONG_TUONG" },
    { label: "Trung tướng", code: "TRUNG_TUONG" },
    { label: "Thiếu tướng", code: "THIEU_TUONG" },
    { label: "Đại tá", code: "DAI_TA" },
    { label: "Thượng tá", code: "THUONG_TA" },
    { label: "Trung tá", code: "TRUNG_TA" },
    { label: "Đại úy", code: "DAI_UY" },
    { label: "Thượng úy", code: "THUONG_UY" }
  ]
};

export default constants;
